export default "__VITE_ASSET__eSbmyH1T__"